import { createContext } from "react";

const MainAppContext = createContext();

export default MainAppContext;
